<template>
  <div v-if="expansivePrivacyPolicyUrl" class="text-center text-xs">
    <i18n-t v-if="hasClientPolicy" keypath="app.privacy.client" tag="p">
      <template #action>
        <a :href="expansivePrivacyPolicyUrl" class="link" target="_blank" rel="noopener noreferrer">
          {{ t('app.privacy.policy') }}
        </a>
      </template>
      <template #lineBreak>
        <br />
      </template>
      <template #clientName>{{ clientName }}</template>
      <template #clientAction>
        <a :href="clientPrivacyPolicyUrl" class="link" target="_blank" rel="noopener noreferrer">
          {{ t('app.privacy.policy') }}
        </a>
      </template>
    </i18n-t>
    <i18n-t v-else keypath="app.privacy.expansive" tag="p">
      <template #action>
        <a :href="expansivePrivacyPolicyUrl" class="link" target="_blank" rel="noopener noreferrer">
          {{ t('app.privacy.policy') }}
        </a>
      </template>
    </i18n-t>
  </div>
</template>

<script setup>
import { useGetConfigVar } from '@/composables/useGetConfigVar.js'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const hasClientPolicy = computed(() => {
  try {
    return useGetConfigVar('CLIENT_PRIVACY_POLICY_URL')?.trim()?.length > 0
  } catch (e) {
    return false
  }
})

const clientName = computed(() => {
  try {
    return useGetConfigVar('CLIENT_NAME')
  } catch (e) {
    return null
  }
})

const clientPrivacyPolicyUrl = computed(() => {
  try {
    return useGetConfigVar('CLIENT_PRIVACY_POLICY_URL')
  } catch (e) {
    return null
  }
})

const expansivePrivacyPolicyUrl = computed(() => {
  try {
    return useGetConfigVar('EXPANSIVE_PRIVACY_POLICY_URL')
  } catch (e) {
    return null
  }
})
</script>
